<script lang="ts">
export default {
  name: 'KkToggleSwitch',
}
</script>

<script setup lang="ts">
export interface Props {
  id: string,
  label: string,
  modelValue: boolean,
  disabled?: boolean
}

interface Emits {
  (e: 'update:modelValue', newValue: boolean): void
}

const props = withDefaults(defineProps<Props>(), {
  id: '',
  label: '',
  modelValue: false,
  disabled: false
})

const emit = defineEmits<Emits>()

const handleChange = (): void => {
  if (props.disabled) return
  emit('update:modelValue', !props.modelValue)
}
</script>

<template>
  <div class="toggle">
    <input
      :id="props.id"
      :checked="modelValue"
      type="checkbox"
      class="toggle__input"
      :disabled="disabled"
      @change="handleChange"
    >
    <label :for="props.id" class="toggle__background" />
    <label :for="props.id" class="toggle__label">
      {{ label }}
    </label>
  </div>
</template>
<style scoped lang="scss">
.toggle {
  &__input {
    opacity: 0;
    top: 0;
    left: 0;
    cursor: pointer;
    &:checked {
      +.toggle__background {
        background-color: #4DA1FF;
        &::after {
          left: 16px;
        }
      }
    }
  }
  &__background {
    display: inline-block;
    position: relative;
    width: 30px;
    height: 16px;
    border-radius: 8px;
    box-sizing: border-box;
    background: #D2D5DB;
    cursor: pointer;
    transition: .4s;
    &::after {
      position: absolute;
      top: 2px;
      left: 2px;
      z-index: 1;
      width: 12px;
      height: 12px;
      border-radius: 100%;
      box-shadow: 0 0 5px rgba(0, 0, 0, .2);
      background: #FFF;
      content: "";
      transition: .4s;
    }
  }
  &__label {
    position: relative;
    bottom: 3px;
    left: 8px;
    cursor: pointer;
  }
}
</style>
